















































































































import { Component, Prop} from 'vue-property-decorator';
import TariffFilter from '@/components/Tarification/TariffFilter.vue';
import { SelectWings, ScrollButton } from 'wings-ui-components';
import {Action, Getter} from 'vuex-class';
import { TariffItem, TarificationTransports, TarificationTypes } from '@/store/tarification/types';
import BaseItemsPage from '../BaseItemsPage';
import ImportTariffs from "@/components/Tarification/ImportTariffs.vue";

@Component({components:{ImportTariffs, TariffFilter, ScrollButton, SelectWings}})
export default class Tariffs extends BaseItemsPage<TariffItem> {

  @Prop() transport!: TarificationTransports;
  @Prop() type!: TarificationTypes;

  @Getter('tariffs') responseItems!: TariffItem[];
  @Getter("messageCategories") messageCategoriesList: any;
  @Action("getMessageCategories") actionMessageCategories: any;

  is_show_filter = false;
  currentSort = 'name';

  private is_show_import = false;

  partnerType: TarificationTypes = TarificationTypes.PARTNER;
  operatorType: TarificationTypes = TarificationTypes.OPERATOR;
  pushTransport: TarificationTransports = TarificationTransports.PUSH;

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return ['partner', 'service_provider', 'price'];
  }

  getData(): TariffItem[] {
    return this.responseItems;
  }

  created() {
    this.actionMessageCategories({transport: this.transport});
  }

  getMessageCategoriesPrices(arr: any) {
    let message: string = ''
    arr.forEach((item: any) => {
      message += this.getMessageCategoriesByName(item.message_category_id) + ': ' + item.price + '<br/>';
    });
    return message;
  }

  getMessageCategoriesByName(id: number): string {
    return this.messageCategoriesList.find((item: any) => item.id == id).name
  }

  get isOperatorType(): boolean {
    return this.type === TarificationTypes.OPERATOR;
  }

  get isSmsOrWhatsappOrViber(): boolean {
    return [
      TarificationTransports.SMS,
      TarificationTransports.WHATSAPP,
      TarificationTransports.VIBER,
      TarificationTransports.CUSTOM,
    ].includes(this.transport);
  }
}
